import React, { Component } from "react";
import PropTypes from "prop-types";
import { Layout } from "antd";
import axios from "axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { Header, Footer, Spinner, Content, ContentLinks } from "./components";

library.add(fal);

class App extends Component {
  state = {
    profile: {}
  };

  componentWillMount() {
    const { userProfile, getProfile } = this.props.auth;
    if (!userProfile) {
      getProfile((err, profile) => {
        this.setState({ profile }, () => this.gotEmail(profile.email));
      });
    } else {
      this.setState({ profile: userProfile }, () =>
        this.gotEmail(userProfile.email)
      );
    }
  }

  gotEmail = email => {
    //do stuff once email is fetched from auth token endpoint
    //analytics?, user settings?
    // /* Create a timer to store the users settings on a regular interval  */
    // setInterval(this.saveUserSettings, config.userSettingSaveInterval);
    //create Apps API instance
    const idToken = localStorage.getItem("id_token");

    const internalAPI = axios.create({
      baseURL: "https://api.internal.pdview.com.au",
      headers: {
        Authorization: `Bearer ${idToken}`
      }
    });

    this.setState({
      internalAPI
    });
  };

  appView = view => {
    switch (view) {
      case "content":
        const file = this.props.match.params.file;
        const internalAPI = this.state.internalAPI;
        if (internalAPI)
          return <Content internalAPI={internalAPI} fileName={file} />;
        else
          return (
            <Spinner
              style={{ margin: "30% auto" }}
              message={"Loading data..."}
            />
          );
      default:
        return (
          <div
            style={{
              backgroundColor: "var(--secondaryColor)",
              padding: "8px 16px"
              // textAlign: "center"
            }}
          >
            <h1>Welcome to pdView Internal Apps</h1>
            <p> Please select an option from side menu</p>
          </div>
        );
    }
  };

  render() {
    const { profile, internalAPI } = this.state;
    const { match } = this.props;
    const view = match.params.view;

    return (
      <Layout
        style={{
          "--primaryColor": "#242424",
          "--primaryTextColor": "#fff",
          "--secondaryColor": "#444",
          backgroundColor: "var(--primaryColor)",
          color: "var(--primaryTextColor)"
        }}
      >
        <Header email={profile.email} />

        <Layout>
          <Layout.Sider
            width={240}
            style={{
              background: "#313131",
              minHeight: "900px"
            }}
          >
            {internalAPI && (
              <ContentLinks
                internalAPI={internalAPI}
                selectedFile={match.params.file}
              />
            )}
          </Layout.Sider>
          <Layout.Content style={{ backgroundColor: "var(--secondaryColor)" }}>
            {this.appView(view)}
          </Layout.Content>
        </Layout>
        <Footer />
      </Layout>
    );
  }
}

App.propTypes = {
  auth: PropTypes.object.isRequired,
  history: PropTypes.object,
  match: PropTypes.object
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js